import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('inn_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const url = String(err?.config?.url || '');
      const ehTelaDeEntrada = url.includes('/auth/login') || url.includes('/auth/google') || url.includes('/auth/esqueci-senha') || url.includes('/auth/redefinir-senha');
      if (!ehTelaDeEntrada) {
        // Sessão vencida: limpa e avisa a aplicação para voltar ao login com uma mensagem clara.
        const tinhaSessao = !!localStorage.getItem('inn_token');
        localStorage.removeItem('inn_token');
        localStorage.removeItem('inn_user');
        if (tinhaSessao) {
          try { sessionStorage.setItem('inn_aviso', 'Sua sessão expirou. Entre novamente para continuar.'); } catch { /* noop */ }
          window.dispatchEvent(new Event('inn:sessao-expirada'));
        }
      }
    }
    return Promise.reject(err);
  }
);

// Auth
export const register = (data) => api.post('/auth/register', data).then((r) => r.data);
export const login = (data) => api.post('/auth/login', data).then((r) => r.data);
export const googleConfig = () => api.get('/auth/google/config').then((r) => r.data);
export const googleLogin = (credential) => api.post('/auth/google', { credential }).then((r) => r.data);
export const esqueciSenha = (email) => api.post('/auth/esqueci-senha', { email }).then((r) => r.data);
export const redefinirSenha = (token, password) => api.post('/auth/redefinir-senha', { token, password }).then((r) => r.data);
export const me = () => api.get('/auth/me').then((r) => r.data);

// Frete
export const calcularFrete = (payload) => api.post('/frete/calcular', payload).then((r) => r.data);

// Envios
export const criarEnvio = (payload) => api.post('/envios', payload).then((r) => r.data);
export const relatorioEnvios = (params) => api.get('/relatorios/envios', { params }).then((r) => r.data);
export const listarEnvios = () => api.get('/envios').then((r) => r.data);
export const enviosStats = () => api.get('/envios/stats').then((r) => r.data);

// Wallet
export const walletSaldo = () => api.get('/wallet/saldo').then((r) => r.data);
export const walletRecarga = (valor, metodo = 'pix') => api.post('/wallet/recarga', { valor, metodo }).then((r) => r.data);
export const walletExtrato = () => api.get('/wallet/extrato').then((r) => r.data);

// Notificações
export const listarNotificacoes = () => api.get('/notificacoes').then((r) => r.data);
export const marcarNotificacoesLidas = () => api.post('/notificacoes/marcar-lidas').then((r) => r.data);

// Carteira de clientes
export const listarContatos = (q) => api.get('/contatos', { params: q ? { q } : {} }).then((r) => r.data);
export const criarContato = (d) => api.post('/contatos', d).then((r) => r.data);
export const atualizarContato = (id, d) => api.put(`/contatos/${id}`, d).then((r) => r.data);
export const excluirContato = (id) => api.delete(`/contatos/${id}`).then((r) => r.data);
export const enviosDoContato = (id) => api.get(`/contatos/${id}/envios`).then((r) => r.data);
export const listarContatosIntegracao = (q) => api.get('/admin/integracao/contatos', { params: q ? { q } : {} }).then((r) => r.data);
export const listarEnviosIntegracao = () => api.get('/admin/integracao/envios').then((r) => r.data);
export const enviosContatoIntegracao = (id) => api.get(`/admin/integracao/contatos/${id}/envios`).then((r) => r.data);

// Pagamento (InfinitePay / Pagar.me)
export const recargaCheckout = (valor) => api.post('/wallet/recarga/checkout', { valor }).then((r) => r.data);
export const recargaPix = (valor) => api.post('/wallet/recarga/pix', { valor }).then((r) => r.data);
export const recargaStatus = (id, params) => api.get(`/wallet/recarga/${id}`, { params }).then((r) => r.data);
export const adminInfinitePayGet = () => api.get('/admin/infinitepay').then((r) => r.data);
export const adminInfinitePaySave = (handle) => api.put('/admin/infinitepay', { handle }).then((r) => r.data);
export const adminRastreioExternoGet = () => api.get('/admin/rastreio-externo').then((r) => r.data);
export const adminRastreioExternoSave = (api_key) => api.put('/admin/rastreio-externo', { api_key }).then((r) => r.data);
export const adminRastreioExternoTestar = () => api.post('/admin/rastreio-externo/testar').then((r) => r.data);
export const rastreioCota = () => api.get('/rastreio-cota').then((r) => r.data);
export const adminRastreioExternoLimite = (limite_cliente_mes) => api.put('/admin/rastreio-externo/limite', { limite_cliente_mes }).then((r) => r.data);
export const adminCorreiosChaveGet = () => api.get('/admin/correios/chave-acesso').then((r) => r.data);
export const adminCorreiosChaveSave = (chave, expira_em) => api.put('/admin/correios/chave-acesso', { chave, expira_em: expira_em || null }).then((r) => r.data);
export const adminCorreiosTestarEtiqueta = () => api.post('/admin/correios/testar-etiqueta').then((r) => r.data);
export const adminPagarmeGet = () => api.get('/admin/pagarme').then((r) => r.data);
export const adminPagarmeSave = (secret_key) => api.put('/admin/pagarme', { secret_key }).then((r) => r.data);
export const adminMercadoPagoGet = () => api.get('/admin/mercadopago').then((r) => r.data);
export const adminMercadoPagoSave = (access_token) => api.put('/admin/mercadopago', { access_token }).then((r) => r.data);
export const adminAsaasGet = () => api.get('/admin/asaas').then((r) => r.data);
export const adminAsaasSave = (api_key) => api.put('/admin/asaas', { api_key }).then((r) => r.data);
export const adminWalletGatewayGet = () => api.get('/admin/wallet-gateway').then((r) => r.data);
export const adminWalletGatewaySave = (pix) => api.put('/admin/wallet-gateway', { pix }).then((r) => r.data);

// Dashboard e acessos
export const adminDashboard = (dias) => api.get('/admin/dashboard', { params: { dias } }).then((r) => r.data);
export const adminCobrancaDireta = (mes) => api.get('/admin/cobranca-direta', { params: mes ? { mes } : {} }).then((r) => r.data);
export const registrarVisita = () => api.post('/visita').catch(() => {});

// Integração com a gestão
export const adminIntegracaoGet = () => api.get('/admin/integracao').then((r) => r.data);
export const adminIntegracaoSave = (limite_diario) => api.put('/admin/integracao', { limite_diario }).then((r) => r.data);
export const adminApiKeys = () => api.get('/admin/api-keys').then((r) => r.data);
export const adminApiKeyCriar = (d) => api.post('/admin/api-keys', d).then((r) => r.data);
export const adminApiKeyRevogar = (id) => api.delete(`/admin/api-keys/${id}`).then((r) => r.data);

// Admin
export const adminUsers = () => api.get('/admin/users').then((r) => r.data);
export const adminStats = () => api.get('/admin/stats').then((r) => r.data);

export const adminCorreiosGet = () => api.get('/admin/correios').then((r) => r.data);
export const adminCorreiosSave = (d) => api.put('/admin/correios', d).then((r) => r.data);
export const adminCorreiosTestar = () => api.post('/admin/correios/testar').then((r) => r.data);

export const adminMargemGet = () => api.get('/admin/margem').then((r) => r.data);
export const adminMargemSave = (margem_percent, desconto_balcao_percent) => api.put('/admin/margem', { margem_percent, desconto_balcao_percent }).then((r) => r.data);
export const adminUserDelete = (id, forcar = false) => api.delete(`/admin/users/${id}`, { params: { forcar } }).then((r) => r.data);
export const adminUserUpdate = (id, body) => api.patch(`/admin/users/${id}`, body).then((r) => r.data);

export const adminTabelaGet = () => api.get('/admin/tabela-precos').then((r) => r.data);
export const adminTabelaUpload = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/admin/tabela-precos/${id}`, fd).then((r) => r.data);
};

// Remetente e etiqueta
export const getRemetente = () => api.get('/auth/remetente').then((r) => r.data);
export const saveRemetente = (d) => api.put('/auth/remetente', d).then((r) => r.data);
export const etiquetaEnvio = (id, formato = '10x15') => api.get(`/envios/${id}/etiqueta`, { params: { formato }, responseType: 'blob', timeout: 90000 }).then((r) => r.data);
export const criarLinkEtiqueta = (id, formato) => api.post(`/envios/${id}/etiqueta/link`, { formato }, { timeout: 90000 }).then((r) => r.data);
export const enviarEtiquetaEmail = (id, para, formato) => api.post(`/envios/${id}/etiqueta/email`, { para, formato }, { timeout: 90000 }).then((r) => r.data);
export const etiquetasLote = (ids, formato) => api.post('/envios/etiquetas/lote', { ids, formato }, { responseType: 'blob', timeout: 180000 })
  .then((r) => ({ blob: r.data, incluidas: Number(r.headers['x-etiquetas-incluidas'] || 0), ignoradas: Number(r.headers['x-etiquetas-ignoradas'] || 0) }));
export const adminEmailGet = () => api.get('/admin/email').then((r) => r.data);
export const adminEmailSave = (d) => api.put('/admin/email', d).then((r) => r.data);
export const adminEmailTestar = () => api.post('/admin/email/testar', null, { timeout: 60000 }).then((r) => r.data);
export const atualizarPerfil = (d) => api.put('/auth/perfil', d).then((r) => r.data);
export const enviarLogo = (file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.put('/auth/logo', fd).then((r) => r.data);
};
export const verLogo = () => api.get('/auth/logo', { responseType: 'blob' }).then((r) => r.data);
export const removerLogo = () => api.delete('/auth/logo').then((r) => r.data);
export const cancelarEnvio = (id) => api.post(`/envios/${id}/cancelar`).then((r) => r.data);
export const excluirEnviosCancelados = () => api.delete('/envios/cancelados').then((r) => r.data);
export const buscarCep = async (cep) => {
  const d = String(cep).replace(/\D/g, '');
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    const j = await r.json();
    return j.erro ? null : { logradouro: j.logradouro || '', bairro: j.bairro || '', cidade: j.localidade || '', uf: j.uf || '' };
  } catch { return null; }
};

// Rastreio
export const rastrear = (codigo) => api.get(`/rastreio/${codigo}`).then((r) => r.data);

export default api;
